import { staticContentService } from '~/api/local-api/localService';
import { RetailerFileSettings } from '~/core/models';

export type RetailerFileSettingsParams = {
  url: string;
};

const retailerFileSettingsService = staticContentService.injectEndpoints({
  endpoints: (builder) => ({
    fetchRetailerFileSettings: builder.query<
      RetailerFileSettings,
      RetailerFileSettingsParams
    >({
      query: ({ url }) => ({
        url,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchRetailerFileSettingsQuery } =
  retailerFileSettingsService;
